import Axios from "../utils/axios";
import { IEmailCategory } from "../interfaces/models/IEmailCategory";

const axios = new Axios();

export const getEmailCategories = async (): Promise<IEmailCategory[]> => {
  const response = await axios.Get("emailCategory");
  return Array.isArray(response?.data) ? response.data : [];
};

export const createEmailCategory = async (
  item: Pick<IEmailCategory, "name">
): Promise<IEmailCategory> => {
  const response = await axios.Post("emailCategory", item);
  return response?.data ?? response;
};
